<template>
    <div :ref="`filter-tag-${filter.code}`" class="listing-table-filters__container">
        <ListingTableFiltersTag
            ref="filter-tag-trigger"
            :type="filter.code"
            :label="filter.activeLabel"
            :valuesHumanized="valuesHumanized"
            @clickOnTag="updateVisibility(true)"
            @removeFilter="removeFilter"
        />
        <CompassPopover
            v-if="TYPES.POPOVER === type"
            v-bind="filterConfig"
            triggerRef="filter-tag-trigger"
            noCloseOnClickOutside=".listing-settings-header__filters-select-dropdown"
            :customClass="`listing-filter-popover ${filterConfig.customClass}`"
            @close="updateVisibility(false)"
        >
            <slot name="filterDropdownContent" />
        </CompassPopover>
        <CompassDropdown
            v-else
            v-bind="filterConfig"
            :parentRef="`filter-tag-${filter.code}`"
            :modelValue="filterValues"
            :filterablePlaceholder="$t.__('common.labels.search')"
            :noResultsLabel="$t.__('common.labels.no_result')"
            blackListedSelector=".listing-settings-header__filters-select-dropdown"
            @onApplied="onApplyFilter"
            @update:modelValue="onSelectFilterValue"
            @update:isVisible="updateVisibility"
        >
            <slot name="filterDropdownContent" />
        </CompassDropdown>
    </div>
</template>

<script>
import ListingTableFiltersTag from 'vcomponents/common/listing/filters/ListingTableFiltersTag.vue';
import { cloneDeep } from 'lodash';

const TYPES = Object.freeze({
    DROPDOWN: 'dropdown',
    POPOVER: 'popover',
});
export default {
    components: {
        ListingTableFiltersTag,
    },
    props: {
        type: {
            type: String,
            default: TYPES.DROPDOWN,
        },
        filter: {
            type: Object,
            required: true,
        },
        valuesHumanized: {
            type: String,
            default: '',
        },
        filterConfig: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            TYPES,
            filterValues: [],
        };
    },
    watch: {
        'filter.optionsSelected': {
            handler() {
                this.filterValues = cloneDeep(this.filter.optionsSelected);
            },
        },
    },
    created() {
        this.filterValues = cloneDeep(this.filter.optionsSelected);
    },
    methods: {
        onApplyFilter() {
            this.updateFilter();
            this.updateVisibility(false);
        },
        onSelectFilterValue(values) {
            this.filterValues = values;
            if (this.filterConfig.appliedButton && this.filterConfig.appliedButton !== '') {
                return;
            }
            this.updateFilter();
            this.updateVisibility(false);
        },
        updateFilter() {
            if (this.filterValues.length === 0) {
                this.removeFilter();
            } else {
                this.$emit('updateFilter', this.filterValues);
            }
        },
        updateVisibility(value) {
            this.$emit('updateVisibility', value);
        },
        removeFilter() {
            this.updateVisibility(false);
            this.$nextTick(() => this.$emit('removeFilter', this.filter.code));
        },
    },
};
</script>
